<button [type]="type()" pButton [ngClass]="classes()"  [disabled]="disabled()" (click)="onClick()">{{label()}}</button>
